var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('search-input',{attrs:{"base-uri":"/article/search","size":_vm.size,"input-class":_vm.inputClass,"placeholder":_vm.placeholder},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }